import { WorkspaceShell } from "@/components/WorkspaceShell";

export default function UserShell() {
  return <WorkspaceShell />;
}
